


export const journey_map = {
  family: 'For family members',
  homecare: 'For homecare agencies',
  nursing:'For nursing homes',
}



export const family_subjourney_map = {
  away: 'I live away from my loved one',
  with: 'I live with my loved one',
}



export const section_map = {
  basics: 'How it works',
  features: 'Features',
  pricing:'Pricing',
  security: 'Safety & security',
  faqs: 'Frequently asked questions',
}




export const coordinator_map = {
  vivian: 'Vivian',
  vicky: 'Vicky',
  veronica:'Veronica',
  vera: 'Vera',
}




export const coordinator_condition_map = {
  vivian: 'Congestive Heart Failure',
  vicky: 'Hip Replacement Surgery',
  veronica:'Chronic Obstructive Pulmonary Disease',
  vera: 'Diabetes',
}




export const coordinator_type_map = {
  vivian: 'Provider',
  vicky: 'Provider',
  veronica:'Payor',
  vera: 'Payor',
}


